import { getNumberFormatter } from "../utility/number-format-cache";

export function formatQuantity(
    quantity: number,
    options?: {
        locale?: string;
        maximumDecimals?: number;
    }
) {
    if (quantity === undefined || quantity === null) {
        return "0";
    }

    if (options?.locale) {
        // Bind the locale to a local so the cache key and the formatter are
        // guaranteed to be built from the same value - inside the callback
        // below, TypeScript widens options.locale back to string | undefined.
        const locale = options.locale;
        // Use `!== undefined` rather than a truthy check, so that
        // maximumDecimals: 0 (meaning "round to a whole number") is
        // respected instead of being treated as "not set".
        const maximumFractionDigits =
            options.maximumDecimals !== undefined
                ? options.maximumDecimals
                : 20;
        const numberFormatter = getNumberFormatter(
            `formatQuantity:${locale}:${maximumFractionDigits}`,
            () =>
                new Intl.NumberFormat(locale, {
                    style: "decimal",
                    maximumFractionDigits,
                })
        );
        return numberFormatter.format(quantity);
    }

    if (options?.maximumDecimals !== undefined) {
        // Same `!== undefined` reasoning as above, plus using 10^n rather
        // than 10*n. The old 10*n factor rounded to the nearest 1/(10n),
        // never to n decimal places - for maximumDecimals: 2 it rounded to
        // the nearest 0.05, so 2.73 came out as 2.75.
        const factor = 10 ** options.maximumDecimals;
        return (Math.round(quantity * factor) / factor).toString();
    }

    return quantity.toString();
}
